<div class="container-fluid mt-5">
  <div class="jumbotron text-center">
    <h1>
      <img src="assets/images/icon2.png" class="logo" />
      <span translate>KIW IT MADE EASY</span>
    </h1>
    <p>
      <i class="far fa-bookmark"></i>&nbsp;<span translate>Version</span>
      {{ version }}
    </p>
  </div>
</div>
